<template>
      <app-left-right>
        <template #left>
          <app-tag-tree @select="selectCategory($event)"></app-tag-tree>
        </template>
        <template #right>
          <app-base-main parentTable :no-padding="true">
            <template #filter-group>
              <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
                <gj-search-input
                  v-model="filter.name"
                  width="200px"
                  placeholder="请输入标签名称"
                ></gj-search-input>
                <gj-select
                  v-model="filter.status"
                  :options="StatusEnum.options"
                  placeholder="全部状态"
                ></gj-select>
              </app-filter-group>
            </template>
            <template #operate-group>
              <gj-button type="primary" @click="addTag" v-if="$permission('tag:add')">新增标签</gj-button>
              <gj-button @click="importTag" v-if="$permission('tag:add')">导入标签</gj-button>
              <gj-button
                :disabled="activeTagBtn"
                @click="activeTag(selectedRows)"
                v-if="$permission('tag:switch')"
                >启用</gj-button
              >
              <gj-button
                :disabled="inactiveTagBtn"
                @click="inactiveTag(selectedRows)"
                v-if="$permission('tag:switch')"
                >停用</gj-button
              >
              <gj-button :disabled="noSelect" @click="deleteTag(selectedRows)" v-if="$permission('tag:delete')"
                >删除</gj-button
              >
            </template>
            <template #tool-group>
              <gj-tool-group
                log
                @viewLog="viewLog"
                help
                :download="$permission('tag:export')"
                download-url="/crm/tag/export"
                :download-params="globalParams">
                <template #before>
                  <gj-button v-if="false" type="primary" @click="exportTag">导出商品标签数据</gj-button>
                </template>
              </gj-tool-group>
            </template>
            <template #table>
              <gj-table
                ref="gjTable"
                adaptParent
                name="productCategory"
                :data="tableData"
                :columns="columns"
                selection
                :loading="loading"
                :default-sort="{ prop: 'state,createTime', order: 'descending' }"
                :pagination="pagination"
                @sort-change="$gjSortChange"
                @page-change="$gjNoticeQuery"
              >

                <template v-slot:state="{row}">
                  <gj-tag
                      type="text"
                      :color="row.state === 'Active'?tagColors.greenText:tagColors.gray9Text">
                    {{row.state === "Active" ? "启用" : "停用" }}
                  </gj-tag>
                </template>

                <template v-slot:op="{ row }">
                  <gj-button-group type="dropdown-op">
                    <gj-button type="text" @click="editTag(row)" v-if="$permission('tag:edit')"
                      >编辑</gj-button
                    >
                    <gj-button
                      v-if="$permission('tag:switch')"
                      type="text"
                      @click="
                        row.state === 'Inactive'
                          ? activeTag([row])
                          : inactiveTag([row])
                      "
                      >{{
                        row.state === "Inactive" ? "启用" : "停用"
                      }}</gj-button
                    >
                    <gj-button type="text" @click="deleteTag([row])" v-if="$permission('tag:delete')"
                      >删除</gj-button
                    >
                  </gj-button-group>
                </template>
              </gj-table>
            </template>
          </app-base-main>
        </template>
      </app-left-right>
</template>

<script>
import AppTagAddModal from "./modal/tag-add-modal";
import AppTagEditModal from "./modal/tag-edit-modal";
import AppTagImportModal from "./modal/tag-import-modal";
import AppTagExportModal from "./modal/tag-export-modal";
import AppTagTree from "./components/tag-tree";
import { selectionMixin, queryMixin, responseMixin } from "../../../../minxins";
import { StatusEnum } from "./common/enum";
import AppTagOpLogModal from "./modal/tag-op-log-modal";
import {tagColors} from "@/components/tag/tag-colors";
import {
  getTagList,
  deleteTag,
  stateSwitchTag,
  deleteBatchTag,
  stateSwitchBatchTag,
} from "../../../../api/system";
import { isMeaningful } from "../../../../utils/common";

export default {
  name: "app-tag-manager",
  components: { AppTagTree },
  mixins: [queryMixin, selectionMixin, responseMixin],
  data() {
    return {
      tagColors,
      columns: [
        { id: "name", header: "标签名称", field: "name", minWidth: "100px" ,sortable: true,},
        { id: "categoryStr", header: "所属分类", field: "categoryStr", minWidth: "100px",sortable: true, sortBy:'fid'},
        { id: "memo", header: "备注", field: "memo", minWidth: "200px" },
        {
          id: "state",
          header: "状态",
          field: "slot:state",
          minWidth: "60px",
          options: [
            { id: "Active", text: "启用" },
            { id: "Inactive", text: "停用" },
          ],
        },
        {
          id: "userName",
          header: "添加用户",
          field: "userName",
          minWidth: "100px",
        },
        {
          id: "createTime",
          header: "添加时间",
          field: "createTime",
          minWidth: "200px",
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          width: "150px",
          fixed: "right",
          notCustomColumn: true,
        },
      ],
      StatusEnum: StatusEnum,
      tableData:[],
      filter: {
        name: null,
        status: null,
        currentCategoryId: null,
      },
      notStorage: true
    };
  },
  created() {
    this.sort.prop = 'state,createTime';
    this.sort.order='ascending,descending'
  },
  computed: {
    // 批量启用
    activeTagBtn() {
      let res = true;
      if (this.selectedRows.length < 1) {
        return res;
      } else {
        this.selectedRows.map((item) => {
          if (item.state === "Active") {
            res = false;
          }
        });
        return !res;
      }
    },
    // 批量停用
    inactiveTagBtn() {
      let res = true;
      if (this.selectedRows.length < 1) {
        return res;
      } else {
        this.selectedRows.map((item) => {
          if (item.state === "Inactive") {
            res = false;
          }
        });
        return !res;
      }
    },
  },
  methods: {
    $gjQueryInitParams() {
      return {
        filter: {
          name: null,
          status: null,
          currentCategoryId: null,
        },
      };
    },
    // 列表分页
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          categoryId: this.filter.currentCategoryId,
          name: this.filter.name,
          state: this.filter.status,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      this.globalParams=params;
      getTagList(params)
        .then((data) => {
          if (isMeaningful(data)) {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          } else {
            this.tableData = [];
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
    viewLog() {
      this.$gjCreate(AppTagOpLogModal, {
        props: {
          url: "",
        },
      });
    },
    addTag() {
      const modal = this.$gjCreate(AppTagAddModal, {
        props: {
          parentId: this.filter.currentCategoryId,
        },
        on: {
          created: () => {
            this.$gjNoticeQuery();
          },
        },
      });
    },
    // 导入标签
    importTag() {
      const modal = this.$gjCreate(AppTagImportModal, {
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          },
          importSuccess: () => {
            modal.$gjDestroy();
          },
        },
      });
    },
    // 导出标签数据
    exportTag() {
      const modal = this.$gjCreate(AppTagExportModal, {
        on: {
          exportSucc: () => {
            // console.log('exportSucc')
          }
        },
      });
    },
    // 标签编辑
    editTag(tag) {
      const modal = this.$gjCreate(AppTagEditModal, {
        props: {
          tag: tag,
        },
        on: {
          created: () => {
            this.$gjNoticeQuery();
          },
        },
      });
    },
    // 标签删除
    deleteTag(rows) {
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: "warning",
          title: "删除确认",
          content: `删除后不可恢复，确定要删除吗？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            if (rows.length > 1) {
              deleteBatchTag({
                ids: rows.map((v) => {
                  return v.id;
                }),
              })
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("删除成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            } else {
              deleteTag(rows[0].id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("删除成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          },
        },
      });
    },
    // 标签停用  / 批量停用
    inactiveTag(rows) {
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: "warning",
          title: "停用确认",
          content: `停用后，在进行打标操作时不可选中此标签，确定要停用吗？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            if (rows.length > 1) {
              const params = {
                ids: rows.map((v) => {
                  return v.id;
                }),
                state: "Inactive",
              };
              stateSwitchBatchTag(params)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("操作成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            } else {
              const params = {
                id: rows[0].id,
                state: "Inactive",
              };
              stateSwitchTag(params)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("操作成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          },
        },
      });
    },
    // 标签启用 / 批量启用
    activeTag(rows) {
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: "warning",
          title: "启用确认",
          content: `启用后，在进行打标操作时可再次选中此标签；确定要启用吗？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            if (rows.length > 1) {
              const params = {
                ids: rows.map((v) => {
                  return v.id;
                }),
                state: "Active",
              };
              stateSwitchBatchTag(params)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("操作成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            } else {
              const params = {
                id: rows[0].id,
                state: "Active",
              };
              stateSwitchTag(params)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success("操作成功");
                    this.$gjNoticeQuery();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          },
        },
      });
    },
    selectCategory(categoryId) {
      this.filter.currentCategoryId = categoryId;
      this.$gjQuery();
    },
    resetTable() {},
  },
};
</script>

<style scoped>
</style>

